import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=20da6e2e"
import script from "./Roles.js?vue&type=script&lang=js&external"
export * from "./Roles.js?vue&type=script&lang=js&external"
import style0 from "./Roles.vue?vue&type=style&index=0&id=20da6e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports